// Danh sách nhóm/kênh/người bot vừa nghe được nhưng CHƯA khai.
// Mục đích: bấm 1 nút là id vào đúng ô, khỏi đi tra chatId bằng tay.
import React from "react";
import { Button, Empty, Tag, Tooltip } from "antd";

/**
 * Loại nguồn suy từ id — Telegram cấp id DƯƠNG cho người, id ÂM cho nhóm/kênh.
 * chatId === senderId nghĩa là tin không lộ người gửi: chat riêng (id dương)
 * hoặc bài kênh (id âm, kênh đứng tên chứ không phải admin nào).
 *
 * Vì sao cần: chat riêng của admin từng hiện là "(nhóm không tên)" nên dễ bấm
 * nhầm "+ Thêm" → khai luôn chat riêng thành nhóm nguồn đăng bài.
 */
export function sourceKind(src) {
    const chatId = String(src.chatId ?? "");
    if (!chatId.startsWith("-")) return "private";
    return String(src.senderId ?? "") === chatId ? "channel" : "group";
}

const KIND = {
    private: { label: "Chat riêng", color: "purple" },
    channel: { label: "Kênh", color: "geekblue" },
    group: { label: "Nhóm", color: "green" },
};

/**
 * Nguồn này đã khai chưa? Chat riêng tính theo ô "báo riêng", nhóm/kênh tính theo
 * bảng nguồn. Dùng chung cho cả nút "đã khai" lẫn số đếm ở đầu bảng cấu hình —
 * hai chỗ đếm theo hai luật khác nhau thì số không khớp với danh sách.
 */
export function isSourceDeclared(src, config) {
    if (sourceKind(src) === "private") {
        return String(config.notifyChatId || "") === String(src.chatId);
    }
    return config.chats.some(
        (c) => c.chatId === String(src.chatId) && (c.threadId || "") === (src.threadId || "")
    );
}

/** Bao nhiêu nguồn còn CHỜ khai (bỏ qua nhóm bình luận vì không khai được). */
export const countPendingSources = (sources, config) =>
    sources.filter((s) => !s.isDiscussionGroup && !isSourceDeclared(s, config)).length;

export default function TelegramRecentSources({ sources, config, onAddSource, onUseAsNotify }) {
    if (!sources.length) {
        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Chưa thấy tin nào — add bot vào nhóm rồi nhắn 1 tin, sau đó mở lại bảng này"
            />
        );
    }

    return (
        <div className="rounded border border-gray-200">
            {sources.map((src) => {
                const kind = sourceKind(src);
                const isPrivate = kind === "private";
                // Đã khai rồi thì không cho bấm lại (bấm nữa cũng không thêm gì)
                const used = isSourceDeclared(src, config);

                return (
                    <div
                        key={`${src.chatId}:${src.threadId || ""}:${src.senderId}`}
                        className="flex items-center gap-2 px-2 py-1.5 border-b border-gray-100 last:border-b-0"
                    >
                        <Tag color={KIND[kind].color} className="m-0">
                            {KIND[kind].label}
                        </Tag>
                        <span className="font-medium">
                            {src.chatTitle || src.senderName || "(không tên)"}
                        </span>
                        <span className="text-xs text-gray-400">{src.chatId}</span>
                        {/* Nhóm: người gửi khác nhóm nên phải hiện thêm. Kênh/chat riêng thì
                            id người trùng id chat — hiện lại lần nữa chỉ tổ rối. */}
                        {String(src.senderId) !== String(src.chatId) && (
                            <span className="text-xs text-gray-400">
                                · người gửi {src.senderName || "?"} {src.senderId}
                            </span>
                        )}
                        {/* Nhóm BÌNH LUẬN của kênh: khai làm nguồn thì mọi câu tán gẫu
                            thành bài trên app kèm push cho follower. Khoá nút luôn —
                            backend cũng chặn, đây chỉ là lớp nhìn thấy được. */}
                        {src.isDiscussionGroup && (
                            <Tag color="orange" className="m-0">
                                nhóm bình luận
                            </Tag>
                        )}
                        <span className="flex-1" />
                        {used ? (
                            <Tag className="m-0">đã khai</Tag>
                        ) : src.isDiscussionGroup ? (
                            <Tooltip title="Đây là nhóm bình luận của kênh, không phải nguồn đăng bài. Khai vào là mọi tin tán gẫu trong nhóm sẽ thành bài trên app. Lệnh /xoa ở mục bình luận vẫn chạy mà không cần khai nhóm này.">
                                <Button size="small" disabled>
                                    Không dùng làm nguồn
                                </Button>
                            </Tooltip>
                        ) : isPrivate ? (
                            <Button size="small" onClick={() => onUseAsNotify(src)}>
                                Dùng để báo riêng
                            </Button>
                        ) : (
                            <Button size="small" onClick={() => onAddSource(src)}>
                                Thêm làm nguồn
                            </Button>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
